import React from 'react';
import './mapiweb.css';

// Asset imports
import mainImage from '../assets/mapiweb/main.png';
import backgrad from '../assets/mapiweb/backgrad.png';
import backblack from '../assets/mapiweb/backblack.png';
import devices1 from '../assets/mapiweb/devices1.png';
import devices2 from '../assets/mapiweb/devices2.png';
import devices3 from '../assets/mapiweb/devices3.png';
import devices4 from '../assets/mapiweb/devices4.png';

import Footer from './Footer';

function MapiWeb() {
  return (
    <div className="App">
      <main className="App-main">
        {/* Top Section - Full Width */}
        <section className="mapiweb-top-section">
          <img src={mainImage} alt="Mapi Web Top" className="mapiweb-top-image" />
          <div className="mapiweb-top-overlay">
            <h1 className="mapiweb-title-main">MAPI</h1>
            <p className="mapiweb-subtitle">Website</p>
          </div>
        </section>

        {/* About/Description Section */}
        <section className="mapiweb-about-section">
          <div className="mapiweb-about-container">
            <h2 className="mapiweb-about-title">Display System</h2>
            <p className="mapiweb-about-text selectable">
              Created adaptive data visualization system with multi-level detail —
              from general status to specific records. Interface solutions underwent user
              testing and confirmed effectiveness of hierarchical information presentation.
            </p>
          </div>
        </section>

        {/* Devices 1 Section */}
        <section className="mapiweb-devices-section">
          <img src={backgrad} alt="Background" className="mapiweb-devices-bg" />
          <div className="mapiweb-devices-container">
            <img src={devices1} alt="Devices 1" className="mapiweb-devices-1" />
          </div>
        </section>

        {/* Devices 2 Section */}
        <section className="mapiweb-bridge-section">
          <img src={backblack} alt="Background" className="mapiweb-bridge-bg" />
          <div className="mapiweb-bridge-container">
            <div className="mapiweb-bridge-info">
              <div className="mapiweb-square">
                <span className="mapiweb-bridge-title">Integrated cross-platform experience</span>
                <span className="mapiweb-bridge-text">
                  From web-based product introduction to mobile app interaction, with shared
                  design principles and brand consistency
                </span>
              </div>
            </div>
            <img src={devices2} alt="Devices 2" className="mapiweb-devices-2" />
          </div>
        </section>

        {/* Devices 3 Section */}
        <section className="mapiweb-bridge-section">
          <img src={backgrad} alt="Background" className="mapiweb-bridge-bg" />
          <div className="mapiweb-bridge-container mapiweb-bridge-reverse">
            <div className="mapiweb-bridge-info">
              <div className="mapiweb-square mapiweb-square-2">
                <span className="mapiweb-bridge-title">Web-to-Mobile Bridge</span>
                <span className="mapiweb-bridge-text">
                  Conversion-focused web interface bridging product discovery to app installation,
                  featuring progressive onboarding steps and interactive map preview to drive downloads
                </span>
              </div>
            </div>
            <img src={devices3} alt="Devices 3" className="mapiweb-devices-3" />
          </div>
        </section>

        {/* Devices 4 Section */}
        <section className="mapiweb-devices-section">
          <img src={backblack} alt="Background" className="mapiweb-devices-bg" />
          <div className="mapiweb-devices-container">
            <img src={devices4} alt="Devices 4" className="mapiweb-devices-4" />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default MapiWeb;
